export function getByName (state) {
	return name => state.competitions.find(competition => competition.name === name);
}
